import React from 'react';
import './Spinner.css';

export interface SpinnerProps {
    size?: "large" | "small"
}

export const Spinner: React.FC<SpinnerProps> = (props) => {

    return (
        <span className={`${props.size === "large" ? "size-large" : props.size === "small" ? "size-small" : ""} loader`}></span>
    )
}